import { Flex } from '@hopin-team/ui-flex';
import { Spinner } from '@hopin-team/ui-spinner';
import React from 'react';

export const Loading = ({ id }: { id: string }) => (
  <Flex justifyContent="center" my={2} data-testid={id}>
    <Spinner isShowing pattern="jumbo" isPolite />
  </Flex>
);
